// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2VfQU","emails":"CreateEditClinics_emails__1T1B2","emailTagLabel":"CreateEditClinics_emailTagLabel__4KL85"};